import { Popover } from "react-tiny-popover";
import {
  AvatarCircle,
  AvatarCircleWithoutPadding,
  LogoutButton,
  LogoutModal,
  LogoutNav,
  LogoutNavIcon,
  LogoutNavText,
  Name,
  Wrapper,
} from "./ProfileMenu.styles";
import {
  UserFilled,
  ArrowIndicatorDownOutlined,
  LockOutlined,
  FlameOutlined,
  MoonOutlined,
  GlobeOutlined,
} from "@gds-react/icons";
import { useEffect, useMemo, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useStore } from "../../store/store";
import useCoreContext from "@gf-core/widgets/hooks/useCoreContext";
import SwitchLanguageModal from "../SwitchLanguageModal";
import { useTranslation } from "react-i18next";
import { getEmoji } from "language-flag-colors";

export default function ProfileMenu() {
  const { t } = useTranslation();
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const authSource = account?.idTokenClaims?.authenticationSource;
  const [open, setOpen] = useState(false);
  const setTheme = useStore.useSetTheme();
  const theme = useStore.useTheme();
  const language = useStore.useLanguageSettings();
  const { setTheme: setCoreTheme } = useCoreContext();
  const setLoginHint = useStore.useSetLoginHint();
  const [showLanguagePicker, setShowLanguagePicker] = useState(false);

  const onLogout = () => {
    setLoginHint("");
    instance.logout();
  };

  useEffect(() => {
    setCoreTheme({ appearance: theme, mode: "edge" });
  }, [theme]);

  const flagEmoji = useMemo(() => {
    return getEmoji(language.iso639Code) ?? getEmoji(language.languageName);
  }, [language]);

  const renderPopupContent = () => {
    return (
      <LogoutModal>
        <LogoutNav
          onClick={() => {
            setShowLanguagePicker(true);
          }}
        >
          <LogoutNavIcon>
            {flagEmoji ? (
              flagEmoji
            ) : (
              <GlobeOutlined style={{ width: 20, height: 20 }} />
            )}
          </LogoutNavIcon>
          <LogoutNavText>{t("profileMenu.changeLanguage")}</LogoutNavText>
        </LogoutNav>
        <LogoutNav
          onClick={() => {
            setTheme("light");
          }}
        >
          <LogoutNavIcon>
            <FlameOutlined style={{ width: 20, height: 20 }} />
          </LogoutNavIcon>
          <LogoutNavText>{t("profileMenu.light")}</LogoutNavText>
        </LogoutNav>
        <LogoutNav
          onClick={() => {
            setTheme("dark");
          }}
        >
          <LogoutNavIcon>
            <MoonOutlined style={{ width: 20, height: 20 }} />
          </LogoutNavIcon>
          <LogoutNavText>{t("profileMenu.dark")}</LogoutNavText>
        </LogoutNav>
        <LogoutNav onClick={onLogout}>
          <LogoutNavIcon>
            <LockOutlined style={{ width: 20, height: 20 }} />
          </LogoutNavIcon>
          <LogoutNavText>{t("profileMenu.logout")}</LogoutNavText>
        </LogoutNav>
      </LogoutModal>
    );
  };

  return (
    <>
      <Popover
        isOpen={open}
        positions={["bottom", "right"]}
        align="end"
        containerStyle={{ padding: "20px 0", zIndex: "1000" }}
        content={renderPopupContent()}
        onClickOutside={() => setOpen(false)}
      >
        <Wrapper onClick={() => setOpen(true)}>
          {authSource === "GrundfosInternal" ? (
            <AvatarCircleWithoutPadding>
              <img src="/assets/images/entraid.svg" alt="entraid" />
            </AvatarCircleWithoutPadding>
          ) : (
            <AvatarCircle>
              <UserFilled />
            </AvatarCircle>
          )}

          <Name data-dd-privacy="mask">
            {account?.idTokenClaims?.signInName as string}
          </Name>

          <LogoutButton>
            <ArrowIndicatorDownOutlined style={{ width: 24 }} />
          </LogoutButton>
        </Wrapper>
      </Popover>

      <SwitchLanguageModal
        show={showLanguagePicker}
        onClose={() => setShowLanguagePicker(false)}
      />
    </>
  );
}
